module.exports = __webpack_public_path__ + "static/media/ic-cart-open.a0cba1bb.svg";